import { render, staticRenderFns } from "./TargetsTable.vue?vue&type=template&id=01d7a594&scoped=true&"
import script from "./TargetsTable.vue?vue&type=script&lang=js&"
export * from "./TargetsTable.vue?vue&type=script&lang=js&"
import style0 from "./TargetsTable.vue?vue&type=style&index=0&id=01d7a594&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d7a594",
  null
  
)

export default component.exports